import { createSlice } from '@reduxjs/toolkit';
import { createThunkDictionary } from '../../services/helpers/thunk';

import {
  httpGetBedrooms,
  httpGetBathrooms,
} from '../../services/http/dictionaries';

export const selectBedrooms = (state) => state.dictionaries.bedrooms;
export const selectBathrooms = (state) => state.dictionaries.bathrooms;

const initialState = {
  bedrooms: [],
  bathrooms: [],
};

export const getBedrooms = createThunkDictionary(
  'dictionaries/getBedrooms',
  httpGetBedrooms,
  selectBedrooms,
);

export const getBathrooms = createThunkDictionary(
  'dictionaries/getBathrooms',
  httpGetBathrooms,
  selectBathrooms,
);

export const dictionariesSlice = createSlice({
  name: 'dictionaries',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getBedrooms.fulfilled, (state, action) => {
        state.bedrooms = action.payload;
      })
      .addCase(getBathrooms.fulfilled, (state, action) => {
        state.bathrooms = action.payload;
      });
  },
});

export default dictionariesSlice.reducer;
